import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const AuthShell = ({ eyebrow, title, subtitle, children }) => {
  const { t } = useTranslation();
  const highlights = [
    t('auth.highlights.marketContext'),
    t('auth.highlights.assetIntelligence'),
    t('auth.highlights.unifiedWorkspace'),
  ];

  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 140px)',
        px: { xs: 2, sm: 3, md: 4 },
        py: { xs: 4, md: 6 },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 1180,
          display: 'grid',
          gap: { xs: 3, md: 4 },
          gridTemplateColumns: { xs: '1fr', md: '1.1fr 0.9fr' },
        }}
      >
        <Box
          sx={{
            p: { xs: 3, md: 4.5 },
            borderRadius: 6,
            border: '1px solid rgba(126, 144, 168, 0.14)',
            background:
              'linear-gradient(145deg, rgba(9, 18, 32, 0.96), rgba(9, 18, 32, 0.74))',
            boxShadow: '0 32px 80px rgba(0, 0, 0, 0.24)',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              background:
                'radial-gradient(circle at top left, rgba(88, 196, 221, 0.16), transparent 30%), radial-gradient(circle at bottom right, rgba(245, 195, 107, 0.12), transparent 24%)',
              pointerEvents: 'none',
            }}
          />
          <Stack spacing={3} sx={{ position: 'relative' }}>
            <Chip
              label={eyebrow}
              sx={{
                width: 'fit-content',
                color: '#58C4DD',
                border: '1px solid rgba(88, 196, 221, 0.22)',
                backgroundColor: 'rgba(88, 196, 221, 0.08)',
                fontWeight: 700,
                letterSpacing: 0.4,
              }}
            />
            <Box>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: '2rem', md: '3.4rem' },
                  lineHeight: 1.02,
                  fontWeight: 700,
                  maxWidth: 540,
                }}
              >
                {title}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mt: 2,
                  maxWidth: 560,
                  color: 'rgba(223, 232, 241, 0.76)',
                  fontSize: { xs: '1rem', md: '1.08rem' },
                  lineHeight: 1.7,
                }}
              >
                {subtitle}
              </Typography>
            </Box>
            <Stack spacing={1.25}>
              {highlights.map((item) => (
                <Box
                  key={item}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.25,
                    color: '#D8E4F0',
                    fontSize: '0.96rem',
                  }}
                >
                  <Box
                    sx={{
                      width: 10,
                      height: 10,
                      borderRadius: '50%',
                      background:
                        'linear-gradient(135deg, rgba(88,196,221,1), rgba(245,195,107,0.9))',
                      boxShadow: '0 0 20px rgba(88, 196, 221, 0.35)',
                    }}
                  />
                  <Typography variant="body2" sx={{ color: 'inherit' }}>
                    {item}
                  </Typography>
                </Box>
              ))}
            </Stack>
          </Stack>
        </Box>
        <Box
          sx={{
            p: { xs: 2.5, md: 3 },
            borderRadius: 6,
            border: '1px solid rgba(126, 144, 168, 0.14)',
            background: 'rgba(10, 19, 34, 0.92)',
            boxShadow: '0 24px 70px rgba(0, 0, 0, 0.22)',
            backdropFilter: 'blur(18px)',
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default AuthShell;
